export default __webpack_public_path__ + "static/media/Andrez.ab9ad568.png";